import {
    INSERT_WAYPOINT,
    REMOVE_WAYPOINT,
    EDIT_WAYPOINT,
    PREVIEW_WAYPOINT,
    SET_WAYPOINTS,
    SWAP_WAYPOINTS
} from '@/store/actions/edit_ride/waypoints';

import { arraySwap } from '@/helpers/functions';
import { WaypointType } from '@/helpers/constants';

/** Removes dots on the start and the end of state (not between waypoints). */
const tieUpLooseEnds = (state) => {
    const i = state.findIndex(
        (waypoint) => waypoint.type !== WaypointType.WAYPOINT
    );
    const j = state
        .slice()
        .reverse()
        .findIndex((waypoint) => waypoint.type !== WaypointType.WAYPOINT);
    return i >= 0 ? state.slice(i, state.length - j) : [];
};

export const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case INSERT_WAYPOINT: {
            const { waypoint, index } = action.data;
            return state
                .slice(0, index)
                .concat([waypoint])
                .concat(state.slice(index));
        }

        case PREVIEW_WAYPOINT: {
            const { id, edits } = action.data;

            return state.map((point) =>
                point.id === id ? { ...point, ...edits } : point
            );
        }

        case EDIT_WAYPOINT: {
            const { id, edits } = action.data;

            return state.map((point) =>
                point.id === id ? { ...point, ...edits } : point
            );
        }

        case REMOVE_WAYPOINT: {
            const { id, offRoad, i } = action.data;
            const includesId = !!state.find((o) => o.id === id);
            if (offRoad) {
                if (includesId) return state.filter((point) => point.id !== id);
                if (!!i && !includesId)
                    return state.filter((_, wp) => wp !== i);
            }
            if (!!id && includesId) state.filter((point) => point.id !== id);
            if (i) state.filter((_, wp) => wp !== i);
            return tieUpLooseEnds(state.filter((point) => point.id !== id));
        }

        case SET_WAYPOINTS: {
            return action.data;
        }

        case SWAP_WAYPOINTS: {
            const { a, b } = action.data;
            const aIndex = state.indexOf(a);
            const bIndex = state.indexOf(b);
            return aIndex >= 0 && bIndex >= 0
                ? arraySwap(state, aIndex, bIndex)
                : state;
        }

        default: {
            return state;
        }
    }
};
